import React from 'react';
import { useLang } from '../LanguageContext';

const FLAGS = {
  ru: '🇷🇺',
  en: '🇬🇧',
  ua: '🇺🇦',
  he: '🇮🇱',
  es: '🇪🇸',
};

const SHORT_LABELS = {
  ru: 'RU',
  en: 'EN',
  ua: 'UA',
  he: 'HE',
  es: 'ES',
};

export default function LanguageSelector({ className = '', variant = 'default' }) {
  const { lang, setLang, translations } = useLang();
  const isCompact = variant === 'compact';
  const selectClassName = isCompact
    ? `shefa-language-compact__select ${className}`.trim()
    : `form-select w-auto bg-white text-dark border-0 ${className}`.trim();

  if (isCompact) {
    return (
      <label className="shefa-language-compact">
        <i className="fas fa-globe" aria-hidden="true" />
        <span className="visually-hidden">{translations[lang]?.language || lang}</span>
        <select
          className={selectClassName}
          value={lang}
          onChange={(e) => setLang(e.target.value)}
          aria-label={translations[lang]?.language || lang}
        >
          {Object.entries(translations)
            .filter(([key]) => key !== 'uk')
            .map(([key]) => (
              <option key={key} value={key} style={{ color: '#212529', backgroundColor: '#ffffff' }}>
                {SHORT_LABELS[key] || key.toUpperCase()}
              </option>
            ))}
        </select>
      </label>
    );
  }

  return (
    <select
      className={selectClassName}
      value={lang}
      onChange={(e) => setLang(e.target.value)}
    >
      {Object.entries(translations)
        .filter(([key]) => key !== 'uk')
        .map(([key, val]) => (
        <option
          key={key}
          value={key}
          style={{ color: '#212529', backgroundColor: '#ffffff' }}
        >
          {FLAGS[key]} {val.language}
        </option>
      ))}
    </select>
  );
}
